const baseUrl = `${import.meta.env.VITE_AM_CORE}/uf-auth-cookie-cleaner/delete-cookies`

const cookieDomain = `.${import.meta.env.VITE_ENV}.aschehoug.cloud`

const cookiesToDelete = {
  'am-frontend-sso': cookieDomain,
  'am-sticky': cookieDomain,
  'amlbcookie': cookieDomain,
}
const returnUrl = `${import.meta.env.VITE_HOST}`

export const createDefaultCookieDeletionUrl = () => createCookieDeletionUrl(baseUrl, cookiesToDelete, returnUrl)

export const createCookieDeletionUrl = (baseUrl: string, cookies: typeof cookiesToDelete, returnUrl: string) => {
  const queryString = Object.entries(cookies)
    .map(([cookieName, domain]) => `cookies[${encodeURIComponent(cookieName)}]=${encodeURIComponent(domain)}`)
    .join('&')

  return `${baseUrl}?${queryString}&returnUrl=${encodeURIComponent(returnUrl)}`
}

export const createCookieDeletionUrlWithReturnUrl = (returnUrl: string) => createCookieDeletionUrl(baseUrl, cookiesToDelete, returnUrl)
